module.exports = "/static/assets/7a564b316d8659a75be31b3bde89ba34.gif";